import React from "react";
import classes from "./ApplicationInfoFieldItem.module.css";

interface IApplicationInfoItemProps
  extends React.HTMLAttributes<HTMLDivElement> {
  label: React.ReactNode;
  labelProps?: React.HTMLAttributes<HTMLDivElement>;
  valueProps?: React.HTMLAttributes<HTMLDivElement>;
  value: React.ReactNode;
}

export const ApplicationInfoItem = ({
  label,
  labelProps = {},
  valueProps = {},
  value,
  className = "",
  ...restProps
}: IApplicationInfoItemProps) => {
  const concatContainerClassName = `${className} ${classes.applicationInfoItem}`;
  const concatLabelClassName = `${classes.infoItemName} ${labelProps?.className ? labelProps.className : ""}`;
  const concatValueClassName = `${classes.infoItemValue} ${valueProps?.className ? valueProps.className : ""}`;
  return (
    <div {...restProps} className={concatContainerClassName}>
      <div {...labelProps} className={concatLabelClassName}>
        {label}
      </div>
      <div {...valueProps} className={concatValueClassName}>
        {value}
      </div>
    </div>
  );
};
